export enum PopoverCloseReason {
  MOVE_TO_START = 'moveToStart',
  MOVE_TO_END = 'moveToEnd',
  ARROW_KEY = 'arrowKey',
}
